import { ChartOptions } from "chart.js";

export const getMarginTransactionsChartOptions = (): ChartOptions<"bar"> => ({
  scales: {
    y: {
      type: "linear",
      position: "left",
      beginAtZero: false,
    },
    y1: {
      type: "linear",
      position: "right",
      beginAtZero: false,
      grid: {
        drawOnChartArea: false,
      },
    },
  },
});
